var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1C2154"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.305 7.037c.377.172.543.617.371.994-.28.612-.426 1.28-.426 1.969 0 2.623 2.127 4.75 4.75 4.75v-1.526c0-.08.032-.156.088-.212.1-.1.254-.115.37-.043l.054.043 1.993 1.993c.246.246.27.63.074.903l-.074.087-1.993 1.993c-.056.056-.132.088-.212.088-.142 0-.261-.099-.292-.231l-.008-.07V16.25c-3.452 0-6.25-2.798-6.25-6.25 0-.905.193-1.785.561-2.592.172-.377.617-.543.994-.371zm4.607-5.025c.056.056.088.133.088.212V3.75c3.452 0 6.25 2.798 6.25 6.25 0 .915-.197 1.803-.573 2.617-.173.376-.619.54-.995.366-.376-.173-.54-.619-.367-.995.285-.618.435-1.291.435-1.988 0-2.55-2.01-4.631-4.533-4.745L10 5.249 10 6.776c0 .165-.134.3-.3.3-.08 0-.156-.032-.212-.088L7.495 4.995c-.273-.273-.273-.717 0-.99l1.993-1.993c.117-.117.307-.117.424 0z",
    transform: "translate(-1305 -182) translate(1303 180) translate(2 2)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefresh);
export default __webpack_public_path__ + "static/media/icon-refresh.c4c16ac3.svg";
export { ForwardRef as ReactComponent };